import { create } from "zustand";

type ModalState = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const useModalStore = create<ModalState>((set) => ({
  open: false,
  setOpen: (value) => set({ open: value }),
}));
